<template>
<VueBarcode class="img-barcode" :id="barcodeId" :value="value" :width="width" :height="height" :textAlign="textAlign" :style="barcodeStyle" :textMargin="textMargin" />
</template>

<script>
import VueBarcode from 'vue-barcode';
export default {
    components: { VueBarcode },
    props: {
        value: {
            type: String,
            required: true
        },
        subId: {
            type:String,
            default: ""
        },
        width: {
            type: Number,
            default: 2
        },
        height: {
            type: Number,
            default: 100
        },
        textAlign: {
            type: String,
            default: "left"
        },
        barcodeStyle: {
            type: String,
            default: "width:100%;height:auto;text-align:center;"
        },
        hideText: {
            type: Boolean,
            default: false
        },
        fontSize: {
            type: String,
            default: "16px"
        },
        textMargin: {
            type: String,
            default: "1"
        }
    },
    computed: {
        formattedBarcode() {
            if (this.value.length === 0) return "";
            return this.value.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
        },
        barcodeId() {
            return `${this.subId}_${this.value}`;
        }
    },
    mounted() {
        this.updateBarcodeText();
    },
    methods: {
        updateBarcodeText() {
            this.$nextTick(() => {
                if (this.hideText) {
                    // const textHeight = parseInt(window.getComputedStyle($(`#${this.value} text`)[0]).fontSize, 10);
                    // const wrapperHeight = parseInt($(".img-barcode").css("height").replace("px", ""));                    
                    // console.log($(`#${this.value} text`).text(), textHeight, wrapperHeight);

                    // $(".img-barcode").css("height", `${wrapperHeight - textHeight}px`);
                    // $($(`#${this.value} rect`)[0]).attr("height", `${wrapperHeight - textHeight}`)
                    $(`#${this.barcodeId} text`).remove();
                } else {
                    $(`#${this.barcodeId} text`).text(this.formattedBarcode);
                    $(`#${this.barcodeId} text`).attr("style", `font-size:${this.fontSize};font-weight:300;color:#666;`);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/CustomBarcode.vue